import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import { SnackBarService } from "../../core/snack-bar.service";
import { ThemeService } from "../../core/theme.service";

import { FileDto } from "../../shared/file-dto.model";
import { Theme } from "../../core/theme.model";

@Component({
    template: require('./theme-settings.component.html'),
    styles: [require('./theme-settings.component.css')]
})
export class ThemeSettingsComponent implements OnInit {
    fileInputFC: FormControl;
    loading: boolean;
    loadingSave: boolean;
    themeForm: FormGroup;
    themeSettings: Theme;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private snackBarService: SnackBarService,
        private themeService: ThemeService) {

        this.fileInputFC = new FormControl();
        this.themeForm = this.fb.group({
            primaryColour: ['', Validators.maxLength(20)],
            navbarLogo: null
        });
    }

    ngOnInit() {
        this.loading = true;

        this.themeService.getTheme()
            .then(theme => {
                this.loading = false;
                this.themeSettings = theme;
                this.primaryColourFC.setValue(theme.primaryColour);
            })
            .catch(err => {
                this.loading = false;
                this.snackBarService.openSnackBar("Error retrieving theme settings.");
            });
    }

    get primaryColourFC(): FormControl { return this.themeForm.get("primaryColour") as FormControl }
    get navbarLogoFC(): FormControl { return this.themeForm.get("navbarLogo") as FormControl; }

    actionsDisabled(): boolean {
        return this.showLoadingSpinner()
        || this.showSaveSpinner();
    }

    getPreviewLogo(): string {
        let imagePreview: string = null;
        if (this.navbarLogoFC != null && this.navbarLogoFC.value != null) {
            const selectedFile = this.navbarLogoFC.value as FileDto;
            imagePreview = `data:image/png;base64,${selectedFile.fileContentBase64}`;
        }

        return imagePreview;
    }

    goToEnquiriesList(): void {
        this.router.navigate(["/enquiries"]);
    }

    validImageFile(imgFile: File): boolean {
        return (imgFile.type === "image/png"
                && imgFile.size <= 100000);
    }

    // refer to docs for File obj structure https://developer.mozilla.org/en-US/docs/Web/API/File
    // code modified from https://nehalist.io/uploading-files-in-angular2/
    onFileChange(event: any) {
        let reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
            let file = event.target.files[0];
            reader.readAsDataURL(file); // see https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            reader.onload = () => {

                if (this.validImageFile(file)) {
                    this.navbarLogoFC.setValue({
                        fileName: file.name,
                        fileType: file.type,
                        // readAsDataURL() returns a string in the form "data:image/png;base64,JVBERi0x..."
                        fileContentBase64: (reader.result as string).split(',')[1]
                    })
                } else {
                    this.snackBarService.openSnackBar("Logo must be PNG and less than 100KB.");
                }

                this.fileInputFC.reset();
            };
        }
    }

    save(): void {
        //if (this.themeForm.invalid()) {
        //    //this.validationHelperService.markAllTouched(this.themeForm);
        //    this.snackBarService.openSnackBar("Please fill in required values.");
        //    return;
        //}

        this.loadingSave = true;
        const themeSettings = this.themeForm.value as Theme;

        this.themeService.update(themeSettings)
            .then(() => {
                this.loadingSave = false;
                this.snackBarService.openSnackBar("Theme settings updated.");
            })
            .catch(err => {
                this.loadingSave = false;
                this.snackBarService.openSnackBar(err);
            });
    }

    showLoadingSpinner(): boolean {
        return this.loading;
    }

    showSaveSpinner(): boolean {
        return this.loadingSave;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/admin/theme-settings/theme-settings.component.ts